<template>
  <div class="container">
    <div class="box">
      <b-button v-if="$hasPermission('channel.contact.add')" class="float-right" @click="newDestination">Nuevo Contacto de canal de venta</b-button>
      <h2>Contactos</h2>
      <hr />
      <b-form
        @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'sales-channel-contacts-index-list') } "
      >
        <div class="row">
          <b-form-group class="col-4" label="Buscar">
            <b-form-input v-model="filters.search" type="text" />
          </b-form-group>
          <b-form-group class="col-2" label=".">
            <b-button type="submit" variant="primary">Buscar</b-button>
          </b-form-group>
        </div>
      </b-form>
      <AjaxTable
        id="sales-channel-contacts-index-list"
        :filters="filters"
        :columns="modelColumns"
        resource="sales-channel-contacts"
      >
        <template v-slot:cell(actions)="row">
          <div class="text-center">
            <b-button
              @click="(event) => userView(row.item,row.index,event)"
              type="button"
              size="sm"
              class="mr-1"
              variant="info"
            >
              <md-icon icon="edit" />
            </b-button>
            <b-button
              @click="(event) => userDelete(row.item,row.index,event)"
				v-if="$hasPermission('channel.contact.delete')"
              type="button"
              size="sm"
              class="mr-1"
              variant="danger"
            >
              <md-icon icon="delete" />
            </b-button>
          </div>
        </template>
      </AjaxTable>
    </div>
    <hr />
    <b-modal
      hide-footer
      static
      id="modal-sales-channel-contacts-view"
      size="lg"
      :title="modalInfo.modelId > 0 ? 'Edición de contacto' : 'Nuevo contacto'"
    >
      <Single
		:unableEdit="unableEdit"
        :model-id="modalInfo.modelId"
        :salesChannelId="filters.id"
        modal-id="modal-sales-channel-contacts-view"
      />
    </b-modal>
  </div>
</template>

<script>
import AjaxTable from "../../helpers/AjaxTable.vue";
import Single from "./Single.vue";
import api from "../../../api.js";

export default {
  props: {
    modelId: {
      type: Number,
      required: false,
      default: -1
    }
  },
  components: { Single, AjaxTable },
  data() {
    return {
		unableEdit: false,
      modalInfo: {
        modelId: -1,
        title: "Destino"
      },
      filters: {
        id: 0,
        search: ""
      },
      modelColumns: [
        { key: "id", label: "ID" },
        // { key: "salesChannel", label: "Canel de venta" },
        { key: "firstName", label: "Nombre" },
        { key: "lastName", label: "Apellido" },
        { key: "phone", label: "Teléfono" },
        { key: "email", label: "Correo" },
        { key: "actions", label: "Acciones" }
      ]
    };
  },
  methods: {
    userView(item, index, event) {
		this.unableEdit=!this.$hasPermission('channel.contact.edit')
      this.modalInfo.modelId = item.id;
      this.modalInfo.salesChannelId = this.filters.id;
      this.$root.$emit(
        "bv::show::modal",
        "modal-sales-channel-contacts-view",
        event.target
      );
    },
    newDestination(event) {
		this.unableEdit = false
      this.modalInfo.modelId = -1;
      this.modalInfo.salesChannelId = this.filters.id;
      this.$root.$emit(
        "bv::show::modal",
        "modal-sales-channel-contacts-view",
        event.target
      );
    },
    userDelete(item) {
      this.$root.showWarning({
        okAction: (event, setLoading, close) => {
          setLoading(true);
          api(this)
            .delete(`/sales-channel-contacts/${item.id}`)
            .then(() => {
              this.$root.showAlert("Registro Eliminado!", {
                variant: "warning"
              });
              this.$root.$emit(
                "bv::refresh::table",
                "sales-channel-contacts-index-list"
              );
              close();
            })
            .catch(err => {
              this.$root.handleRequestError(err);
              close();
            });
        }
      });
    }
  },
  mounted() {
    //this.filters.id = parseInt(new URL(location.href).searchParams.get("id"));
    this.filters.id = this.modelId;
  }
};
</script>

<style>
</style>
